import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/auth-api";
import type { ScopeTreeResponse } from "./types";

export function useScopeTree() {
	return useQuery({
		queryKey: ["scope", "tree"],
		queryFn: () => apiFetch<ScopeTreeResponse>("/scope/tree"),
		staleTime: 5 * 60_000,
	});
}
